import { AiFillStar, AiOutlineClose } from "react-icons/ai";
// import Link from "next/link";
import { useSession } from "next-auth/react";
import BtnsLoaderComponent from "../Reusable/Loaders/BtnsLoader";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { addProductReview } from "@/services/product";
import { validateImgSrc } from "@/utils/global";
import NextImage from "../NextImage";
import { useTranslation } from "react-i18next";
import { getCookies } from "cookies-next";

function AddNewRate({ setShow, product }) {
  const {t} = useTranslation('product')
  const {handshake, mage, quote} = getCookies()
  const [btnLoader, setbtnLoader] = useState(false);
  const { data: session } = useSession();
  const [review, setReview] = useState({
    rating: 5,
    title: "",
    detail: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setReview((review) => ({ ...review, [name]: value }));
  };

  // Handle add rate
  const handleRateAdding = async (e) => {
    console.log(review);
    e.preventDefault();
    setbtnLoader(true);
    addProductReview(
      handshake,
      mage,
      quote,
      review.rating,
      session?.user?.firstname,
      review.title,
      review.detail,
      product?.product_id
    )
      .then(({ data, err, error }) => {
        if (error === null) {
          toast.success(data?.msg);
          return setShow(false);
        }
        toast.error(err.response.data?.msg);
      })
      .finally(() => {
        setbtnLoader(false);
      });
  };

  // Coloring start

  const colorStarts = (iOfStar) => {
    const allStart = document.getElementsByClassName("star-in-add-review");
    const allStartArray = Array.from(allStart);
    for (let k = 0; k < allStartArray.length; k++) {
      const box = allStartArray[k];
      box.setAttribute("fill", "#D1D5DB");
    }
    let ArrOfStart = [];
    for (let j = 0; j <= iOfStar; j++) {
      let eleOfStar = document.getElementById(`star-add-review-product-${j}`);
      eleOfStar.setAttribute("fill", "gold");
      ArrOfStart.push(eleOfStar);
    }
    setReview((prev) => ({ ...prev, rating: ArrOfStart.length }));
  };

  // return session?.user ? (
  return (
    <div className="fixed top-0 left-0 w-screen h-screen z-[4000] bg-lightblack flex items-center justify-center">
      <div className="bg-white w-[768px] max-h-[95vh] overflow-y-auto max-[768px]:w-[98%] mx-auto px-6 py-4 rounded-md red-scrollbar">
        <div className="flex items-center justify-between pb-2 border-b">
          <h1 className="text-xl font-semibold text-red">
            {t("WriteProductReview")}
          </h1>
          <AiOutlineClose
            onClick={() => setShow(false)}
            size="20px"
            className="cursor-pointer"
          />
        </div>
        <div className="flex items-start py-4 border-b">
          <NextImage
            src={validateImgSrc(
              `${process.env.NEXT_PUBLIC_IMAGE_BASEURL}/media/catalog/product${product?.extension_attributes?.product_image}`
            )}
            className="object-contain w-auto h-32 p-1 border rounded-md"
            height={128}
            width={170}
            alt="Prod Rate Img!"
          />
          {product?.name && (
            <h5 className="mx-3 font-semibold">{product?.name}</h5>
          )}
        </div>
        <form onSubmit={(e) => handleRateAdding(e)} className="py-3 ">
          <div className="flex items-center mb-2">
            <h3 className="text-lg font-semibold">
              {t("WhatIsYourEvaluationPfPheProduct?")}
            </h3>
            <div className="flex items-center mx-3">
              {[...Array(5).keys()].map((i) => (
                <AiFillStar
                  id={`star-add-review-product-${i}`}
                  key={i}
                  size="19px"
                  className="star-in-add-review cursor-pointer rotate-45 text-gray-300 duration-200 hover:scale-[1.2]"
                  onClick={() => colorStarts(i)}
                />
              ))}
            </div>
          </div>
          <div className="mb-3">
            <h5 className="mb-1 text-lg font-semibold">
              {t("AddYourDescription")}
            </h5>
            <input
              minLength={10}
              required={true}
              name="title"
              onChange={handleInput}
              placeholder={t("AddYourDescription")}
              className="w-full p-2 border rounded-md outline-0"
            />
          </div>
          <div className="mb-3">
            <h5 className="mb-1 text-lg font-semibold">{t("AddYourRating")}</h5>
            <textarea
              minLength={12}
              required={true}
              name="detail"
              onChange={handleInput}
              className="w-full h-20 p-2 border rounded-md outline-0"
              placeholder={t("AddYourRating")}
            />
          </div>
          <div className="flex items-center justify-between min-h-[3rem]">
            <h5 className="text-base">
              {t("PublishedBy")}{" "}
              <span className="font-bold">{session?.user?.firstname}</span>
            </h5>
            {btnLoader ? (
              <button
                type="button"
                disabled={true}
                className="bg-lightred text-white py-1.5 px-3 rounded-md font-semibold flex justify-center items-center min-w-[7rem] min-h-[2.5rem]"
              >
                <BtnsLoaderComponent
                  spinnerColor={"#fff"}
                  widthTWClass={"h-4"}
                  heightTWClass={"h-4"}
                />
              </button>
            ) : (
              <button
                type="submit"
                className="bg-red text-white py-1.5 px-3 rounded-md font-semibold min-w-[7rem] min-h-[2.5rem]"
              >
                {t("SendReview")}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
  // (
  //   <div className='fixed top-0 left-0 w-screen h-screen z-[4000] bg-lightblack flex items-center justify-center'>
  //     <div className='bg-white w-[50wv] max-h-[85vh] overflow-y-auto max-[768px]:w-[98%] mx-auto p-2 rounded-md min-h-[40vh] flex flex-col justify-between items-center'>
  //       <div className='flex items-center justify-between pb-2 border-b w-[100%]'>
  //         <h1 className='text-2xl font-semibold text-red'>
  //           {t("WriteProductReview")}
  //         </h1>
  //         <AiOutlineClose
  //           onClick={() => setShow(false)}
  //           size='20px'
  //           className='cursor-pointer'
  //         />
  //       </div>
  //       <div className='w-[80%]'>
  //         <h3 className='text-center font-[600]'>
  //           {locale == "ar"
  //             ? "عفوًا، يجب عليك تسجيل الدخول أولا لتتمكن من إضافة رأيك عن المنتج."
  //             : "Sorry; You've to login to add your review."}
  //         </h3>
  //       </div>

  //       <div className='flex justify-center items-center gap-[1rem] my-[1rem]'>
  //         <Link
  //           href='/auth/login'
  //           className='rounded-[4px] border-[1px] border-[red] bg-red text-white duration-200 hover:text-red hover:bg-white px-[1rem] py-[.5rem] min-w-[8rem]'
  //         >
  //           {locale == "ar" ? "تسجيل الدخول" : "Login"}
  //         </Link>
  //         <button
  //           onClick={() => setShow(false)}
  //           className='rounded-[4px] border-[1px] border-[red] bg-white text-red duration-200 hover:text-white hover:bg-red px-[1rem] py-[.5rem] min-w-[8rem]'
  //         >
  //           {locale == "ar" ? "إلغاء" : "CLose"}
  //         </button>
  //       </div>
  //     </div>
  //   </div>
  // );
}

export default AddNewRate;
